import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { StateContext } from '../../StateProvider';
import './Cart.css';
import sanitizeDate from '../../Utilities/functions/SanitizeDate';
import { removeItemFromCart } from '../../Utilities/api';
import { WhiteBackButton } from '../../Utilities/components/Buttons';

import hotelIcon from '../../../assets/Landing/hotelIcon.png';
import daycareIcon from '../../../assets/Landing/daycareIcon.png';
import groomingIcon from '../../../assets/Landing/groomingIcon.png';
import adventureIcon from '../../../assets/Landing/adventureIcon.png';
import shuttleIcon from '../../../assets/Landing/shuttleIcon.png';
import trainingIcon from '../../../assets/Landing/trainingIcon.png';

const Cart = function () {
  const navigate = useNavigate();
  const { user, cart, setCart, cartTotal, cartTotalDiscount, refreshUserData, setBookingData } = useContext(StateContext);
  const [totalPrice, setTotalPrice] = useState(cartTotal);
  const [totalDiscount, setTotalDiscount] = useState(cartTotalDiscount);

  useEffect(function () {
    var total = 0;
    var totalOriginal = 0;
    for (var i = 0; i < cart.length; i++) {
      total += cart[i].discountedPrice;
      totalOriginal += cart[i].originalPrice;
    }
    var totalDiscountAmount = totalOriginal - total;
    setTotalPrice(total);
    setTotalDiscount(totalDiscountAmount);
  }, [cart]);

  function handleMenuButtonClicked(page) {
    navigate("/" + page);
    window.scrollTo(0, 0);
    setBookingData(function (prevData) {
      return Object.assign({}, prevData, { bookingType: page });
    });
    localStorage.setItem('bookingType', page);
  }

  async function removeFromCart(index, itemId) {
    try {
      await removeItemFromCart(itemId);
      var newCart = cart.slice();
      newCart.splice(index, 1);
      setCart(newCart);
      refreshUserData(user.uid);
    } catch (error) {
      console.error('Error removing item from cart:', error);
    }
  }

  function CapitalizeFirstLetter(text) {
    if (!text) return '';
    return text.charAt(0).toUpperCase() + text.slice(1);
  }

  function displayAdditionalServices(services) {
    var serviceNames = {
      grooming: 'Grooming',
      training: 'Training',
      shuttle: 'Shuttle',
      adventure: 'Adventure',
      walk: 'Leash Walk'
    };

    var results = [];
    for (var key in services) {
      if (services.hasOwnProperty(key) && services[key]) {
        results.push(serviceNames[key] || key);
      }
    }
    return results;
  }

  function displayTrainingDetails(trainingOptions) {
    if (!trainingOptions) return '';
    var trainingTypeNames = {
      puppy: 'Puppy Obedience',
      basic: 'Basic Obedience',
      behavior: 'Behavior Modification',
      akc: 'AKC Obedience'
    };
    var trainingType = trainingTypeNames[trainingOptions.selectedTrainingType] || trainingOptions.selectedTrainingType;
    var sessionType = trainingOptions.selectedSessionType
      ? trainingOptions.selectedSessionType.charAt(0).toUpperCase() + trainingOptions.selectedSessionType.slice(1)
      : '';
    return trainingType + ' - ' + sessionType + ' Session';
  }

  function displayShuttleDetails(item) {
    if (!item.bookingInfo) return null;
    if (item.bookingInfo.selectedService === 'Airport') {
      return (
        <ul>
          <li><strong>For</strong> {item.bookingInfo.selectedService}</li>
          <li><strong>Pick Up</strong> {item.bookingInfo.pickUpLocation.split(',')[0]}</li>
          <li><strong>Drop Off</strong> {item.bookingInfo.dropOffLocation.split(',')[0]}</li>
          <li><strong>Flight Number</strong> {item.bookingInfo.flightNumber}</li>
          <li><strong>Terminal</strong> {item.bookingInfo.terminal}</li>
        </ul>
      );
    }
    return (
      <ul>
        <li><strong>For</strong> {item.bookingInfo.selectedService}</li>
        <li><strong>Pick Up</strong> {item.bookingInfo.pickUpLocation.split(',')[0]}</li>
        <li><strong>Drop Off</strong> {item.bookingInfo.dropOffLocation.split(',')[0]}</li>
      </ul>
    );
  }

  function displayMembershipDetails(bookingInfo) {
    if (!bookingInfo) {
      return <ul><li>Membership details unavailable</li></ul>;
    }

    var selectedPackage = null;
    if (bookingInfo.selectedPackage) {
      selectedPackage = bookingInfo.selectedPackage;
    } else if (bookingInfo.membershipOptions && bookingInfo.membershipOptions.selectedPackage) {
      selectedPackage = bookingInfo.membershipOptions.selectedPackage;
    }

    var selectedGroomingPackage = null;
    if (bookingInfo.selectedGroomingPackage) {
      selectedGroomingPackage = bookingInfo.selectedGroomingPackage;
    } else if (bookingInfo.membershipOptions && bookingInfo.membershipOptions.selectedGroomingPackage) {
      selectedGroomingPackage = bookingInfo.membershipOptions.selectedGroomingPackage;
    }

    var membershipPackageNames = {
      Club: 'Pawsible Club Membership',
      Plus: 'Pawsible Plus Membership',
      Basic: 'Basic Daycare Membership',
      Premium: 'Premium Daycare Membership',
      VIP: 'VIP Daycare Membership'
    };

    var groomingPackageNames = {
      Basic: 'Basic Grooming Membership',
      Premium: 'Premium Grooming Membership',
      VIP: 'VIP Grooming Membership'
    };

    var membershipPackage = membershipPackageNames[selectedPackage] || selectedPackage;
    var groomingPackage = groomingPackageNames[selectedGroomingPackage] || selectedGroomingPackage;

    return (
      <ul>
        {membershipPackage ? <li>{membershipPackage}</li> : <li>Membership Selected</li>}
        {groomingPackage ? <li>{groomingPackage}</li> : null}
      </ul>
    );
  }

  function handleCheckoutClicked() {
    if (cart.length > 0) {
      navigate("/profile/checkout");
      window.scrollTo(0, 0);
    }
  }

  function displayDateRange(dateRange) {
    var sanitizedDateRange = sanitizeDate(dateRange).split(' - ');
    if (sanitizedDateRange.length !== 2) return "Invalid Date Range";
    var startDate = sanitizedDateRange[0];
    var endDate = sanitizedDateRange[1];
    if (startDate === endDate) return startDate;
    return startDate + " - " + endDate;
  }

  function formatBookingType(bookingType) {
    if (!bookingType) return '';
    if (bookingType.indexOf('Membership') !== -1 || bookingType.indexOf('membership') !== -1) {
        return 'Membership';
    }
    return bookingType.charAt(0).toUpperCase() + bookingType.slice(1);
  }

  return (
    <div>
      <div className='cart-backdrop'>
        <div className='container'>
          <WhiteBackButton />
          <div className="cart-container">
            {cart.length > 0 ? (
              <div>
                <ul className="cart-list">
                  {cart.map(function (item, index) {
                    return (
                      <li key={index} className="cart-item-container">
                        <div className="cart-item-header-btn-container">
                          {item.bookingInfo && item.bookingInfo.selectedPets && item.bookingInfo.selectedPets.length > 0 ? (
                            <h3 className='cart-item-header'>
                                <span className='cart-item-highlight'>{formatBookingType(item.bookingType)}</span>
                                <span className='cart-item-highlight2'>
                                {' ' + (item.bookingInfo.selectedPets.length === 1
                                    ? item.bookingInfo.selectedPets[0].petName
                                    : item.bookingInfo.selectedPets.map(function (pet, i, arr) {
                                        if (i === arr.length - 1 && i !== 0) {
                                        return ' & ' + pet.petName;
                                        } else if (i === arr.length - 2) {
                                        return pet.petName;
                                        } else {
                                        return pet.petName + ', ';
                                        }
                                    }).join(''))}
                                </span>
                            </h3>
                            ) : (
                            <h3 className='cart-item-header'>
                                <span className='cart-item-highlight'>{formatBookingType(item.bookingType)}</span>
                            </h3>
                            )}
                          <button className="cart-remove-btn" onClick={function () { removeFromCart(index, item.id); }}>Remove</button>
                        </div>

                        <hr className='cart-breakline' />

                        <div className='cart-item-details'>
                          {item.bookingInfo && item.bookingInfo.dateRange
                            ? <p className="cart-item-date"><strong>Date</strong> {displayDateRange(item.bookingInfo.dateRange)}</p>
                            : null}
                          {item.bookingInfo && item.bookingInfo.selectedTimeSlot
                            ? (<p className="cart-item-time"><strong>Time</strong> {item.bookingInfo.selectedTimeSlot}</p>)
                            : null}

                          {item.bookingType === 'Grooming' && item.bookingInfo && item.bookingInfo.groomingOptions ? (
                            <div className='cart-item-options-details'>
                              <p className='cart-item-options-header'>Grooming Details</p>
                              <ul>
                                <li>Pet Size - {CapitalizeFirstLetter(item.bookingInfo.groomingOptions.selectedSize)}</li>
                                {item.bookingInfo.groomingOptions.selectedHaircutStyle
                                  ? <li>Hair Style - {CapitalizeFirstLetter(item.bookingInfo.groomingOptions.selectedHaircutStyle)}</li>
                                  : null}
                              </ul>
                            </div>
                          ) : null}

                          {(item.bookingType === 'Hotel' && item.bookingInfo) ? (
                            <div className='cart-item-options-details'>
                              <p className='cart-item-options-header'>Details</p>
                              <ul>
                                <li>Diet - {CapitalizeFirstLetter(item.bookingInfo.foodPreference)}</li>
                              </ul>
                            </div>
                          ) : null}

                          {(item.bookingType === 'Training' && item.bookingInfo && item.bookingInfo.trainingOptions) ? (
                            <div className='cart-item-options-details'>
                              <p className='cart-item-options-header'>Training Details</p>
                              <p className='cart-item-options-message'>{displayTrainingDetails(item.bookingInfo.trainingOptions)}</p>
                            </div>
                          ) : null}

                          {(item.bookingType === 'Adventure' && item.bookingInfo && item.bookingInfo.selectedPackage) ? (
                            <div className='cart-item-options-details'>
                              <p className='cart-item-options-header'>Adventure Details</p>
                              <p className='cart-item-options-message'>{item.bookingInfo.selectedPackage}</p>
                            </div>
                          ) : null}

                          {(item.bookingType === 'Shuttle' && item.bookingInfo) ? (
                            <div className='cart-item-options-details'>
                              <p className='cart-item-options-header'>Shuttle Details</p>
                              {displayShuttleDetails(item)}
                            </div>
                          ) : null}

                          {(item.bookingType.indexOf('Membership') !== -1 || item.bookingType.indexOf('membership') !== -1) ? (
                            <div className='cart-item-options-details'>
                              <p className='cart-item-options-header'>Membership Details</p>
                              {displayMembershipDetails(item.bookingInfo)}
                            </div>
                          ) : null}

                          {(item.bookingType && (item.bookingType.indexOf('Bundle') !== -1 || item.bookingType.indexOf('bundle') !== -1)) ? (
                            <div className='cart-item-options-details'>
                              <p className='cart-item-options-header'>Bundle Details</p>
                              <ul>
                                <li>
                                  <strong>Package:</strong> {item.bookingInfo && item.bookingInfo.selectedPackage ? item.bookingInfo.selectedPackage : 'N/A'}
                                </li>
                                <li>
                                  <strong>Days Included:</strong> {(item.bookingInfo && item.bookingInfo.selectedPackage === '20-Pack') ? 20 : 10}
                                </li>
                                <li>
                                  <strong>Expiration:</strong> 90 Days
                                </li>
                              </ul>
                            </div>
                          ) : null}

                          {(item.bookingType === 'Gift-card-purchase' && item.bookingInfo) ? (
                            <div className='cart-item-options-details'>
                              <p className='cart-item-options-header'>Gift Card Details</p>
                              <ul>
                                <li>Amount - ${item.bookingInfo.amount}</li>
                                <li>Recipient Email - {item.bookingInfo.recipientEmail}</li>
                              </ul>
                            </div>
                          ) : null}

                          {item.originalPrice === item.discountedPrice ? (
                            <div className="cart-item-price-container">
                              <p className="cart-item-price">${item.originalPrice.toFixed(0)}</p>
                            </div>
                          ) : (
                            <div className="cart-item-price-container">
                              <p className="cart-item-discounted-price">
                                <span className='cart-item-original-price-strike'>${item.originalPrice.toFixed(0)}</span>
                                ${item.discountedPrice.toFixed(2)}
                              </p>
                            </div>
                          )}
                        </div>
                      </li>
                    );
                  })}
                </ul>
              </div>
            ) : (
              <div>
                <h3 className='cart-empty-message'>Your cart is empty.</h3>
                <div className='cart-menu'>
                  <h3 className='cart-menu-header'>Discover our premium services and book now!</h3>
                  <div className="container cart-menu-container">
                    <div className="row">
                      <div className="col cart-menu-button-container">
                        <div className='cart-button-image-container'>
                          <img className="cart-menu-button-image" src={hotelIcon} alt="Hotel Icon" onClick={function () { handleMenuButtonClicked('store/services/hotel'); }} />
                        </div>
                        <p className="cart-menu-button-title">Hotel</p>
                      </div>
                      <div className="col cart-menu-button-container">
                        <div className='cart-button-image-container'>
                          <img className="cart-menu-button-image" src={daycareIcon} alt="Daycare Icon" onClick={function () { handleMenuButtonClicked('store/services/daycare'); }} />
                        </div>
                        <p className="cart-menu-button-title">Daycare</p>
                      </div>
                      <div className="col cart-menu-button-container">
                        <div className='cart-button-image-container'>
                          <img className="cart-menu-button-image" src={groomingIcon} alt="Grooming Icon" onClick={function () { handleMenuButtonClicked('store/services/grooming'); }} />
                        </div>
                        <p className="cart-menu-button-title">Grooming</p>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col cart-menu-button-container">
                        <div className='cart-button-image-container'>
                          <img className="cart-menu-button-image" src={trainingIcon} alt="Dog Training Icon" onClick={function () { handleMenuButtonClicked('store/services/training'); }} />
                        </div>
                        <p className="cart-menu-button-title">Training</p>
                      </div>
                      <div className="col cart-menu-button-container">
                        <div className='cart-button-image-container'>
                          <img className="cart-menu-button-image" src={adventureIcon} alt="Adventure Icon" onClick={function () { handleMenuButtonClicked('store/services/adventure'); }} />
                        </div>
                        <p className="cart-menu-button-title">Adventure</p>
                      </div>
                      <div className="col cart-menu-button-container">
                        <div className='cart-button-image-container'>
                          <img className="cart-menu-button-image" src={shuttleIcon} alt="Shuttle Icon" onClick={function () { handleMenuButtonClicked('store/services/shuttle'); }} />
                        </div>
                        <p className="cart-menu-button-title">Shuttle</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="cart-total-container">
        <h3 className='cart-total'>Total ${totalPrice.toFixed(2)}</h3>
        <h3 className='cart-savings'>Saving <span className='cart-savings-highlight'>(${totalDiscount.toFixed(2)})</span></h3>
        <button className="cart-checkout-btn" onClick={handleCheckoutClicked}>Checkout</button>
      </div>
    </div>
  );
};

export default Cart;
